import { render, staticRenderFns } from "./ErrorTenantInvalid.vue?vue&type=template&id=29c0a93f"
import script from "./ErrorTenantInvalid.vue?vue&type=script&lang=js"
export * from "./ErrorTenantInvalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports